import React, { useState, useEffect } from "react";
import "./BudgetReportDashboard.css";
import { useHistory } from "react-router-dom";
import { BudgetReportMain } from "./DashboardReportComponents/BudgetReportMain";
import { BudgetReportChartMain } from "./DashboardReportComponents/BudgetReportChartMain";
import axios from "axios";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import ROUTES from "../../config/routes";
import BUDGET_API from "../../apis/budget.api";
export const BudgetReportDashboard = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState(null);

  const getBudgetReport = async () => {
    try {
      setLoading(true);
      const response = await BUDGET_API.fetchBudgetSummed();
      console.log("response Summed", response);
      if (
        response &&
        response.status === 200 &&
        response.data
      ) {
        setReportData(response.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching user data:", error);
    }
  };
  useEffect(() => {
    getBudgetReport();
  }, []);
  return (
    <div className="reportsMain">
      <div className="reportcreate" style={{ justifyContent: "space-between" }}>
        <h3 className="BudgetReportheading">Budget Report</h3>
        <button
          className="addbuttonreport"
          onClick={() => {
            history.push("/reports/budgetDetails");
          }}
        >
          {" "}
          Create Report
        </button>
      </div>

      <div className="dashboardMainReport">
        <BudgetReportMain data={reportData && reportData} />
      </div>
      <div className="reportTableCard">
        <BudgetReportChartMain data={reportData && reportData} />
      </div>
      <NewLoader isLoading={loading}/>
    </div>
  );
};
